import { useContext } from "react";
import { BotFormContext } from "@shared/features/bots/BotForm/common/BotForm.context";
import { getHedgingExposureBreakdown } from "@shared/features/bots/BotForm/common/utils";
import { BotType } from "@shared/types";

/**
 * Reads the current BotForm context and returns the hedging bot's long/short
 * exposure breakdown (ratios + USD amounts), or undefined when it can't be
 * determined. See {@link getHedgingExposureBreakdown}.
 */
const useHedgingExposureBreakdown = () => {
  const {
    botAmountData,
    longHedgingRatio,
    parsedEntries,
    symbolPriceData,
    formValues,
    botType,
  } = useContext(BotFormContext)!;

  return botType === BotType.HEDGING
    ? getHedgingExposureBreakdown(
        formValues,
        longHedgingRatio,
        botAmountData,
        parsedEntries,
        symbolPriceData?.data
      )
    : undefined;
};

export default useHedgingExposureBreakdown;
